module.exports = __webpack_public_path__ + "img/ljdk_zhTc.74f2a454.png";